import { ReportingOption } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';

type ReportingRequirementType = {
  locationsRequired: boolean;
  departmentsRequired: boolean;
};

export function transformReportingUItoModel(
  reporting: ReportingOption
): ReportingRequirementType {
  if (reporting === ReportingOption.LOCATIONS_REPORTING_OPTION) {
    return {
      locationsRequired: true,
      departmentsRequired: false,
    };
  }

  if (reporting === ReportingOption.DEPARTMENTS_REPORTING_OPTION) {
    return {
      locationsRequired: false,
      departmentsRequired: true,
    };
  }

  return {
    locationsRequired: false,
    departmentsRequired: false,
  };
}

export function transformReportingModelToUI({
  locationsRequired,
  departmentsRequired,
}: ReportingRequirementType): ReportingOption {
  if (locationsRequired) {
    return ReportingOption.LOCATIONS_REPORTING_OPTION;
  }

  if (departmentsRequired) {
    return ReportingOption.DEPARTMENTS_REPORTING_OPTION;
  }

  return ReportingOption.NONE_REPORTING_OPTION;
}
